import get from 'lodash/get';
import { createSelector } from 'reselect';

import { IRootReducer } from '../../reducers/rootReducer';
import { IExportState } from './exportTypes';


const exportSelector = (state: IRootReducer) => get(state, 'exports', {}) as IExportState;

export const getDataForExport = () =>
    createSelector(
        exportSelector,
        state => ({
            fileFormat: state.fileFormat,
        }),
    );
